import { Box, Typography } from "@mui/material";
import { useStyle } from "./homeBroadbandPrequalAddressStyle";
import { addressFormatter } from "@utils/addressFormatter";
import { IAddress } from "@interface/customerDetails/IAddress";
import { ChangeAddressLink } from "@common/ChangeAddressLink/ChangeAddressLink";

interface IParams {
    address: IAddress;
    handleChangeAddress(): void;
}

export const HomeBroadbandPrequalAddress = (props: IParams) => {
    const { address, handleChangeAddress } = props;
    const { classes } = useStyle();

    return (
        <Box alignItems="center" display="flex" flexDirection="column">
            <div className={classes.address}>
                <Typography color="secondary" textAlign="center" variant="normal">
                    {addressFormatter(address, true)}
                </Typography>
            </div>
            <ChangeAddressLink handleChangeAddress={handleChangeAddress} />
        </Box>
    );
};
